import React from 'react';

import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').GenericCardsBlock}
 */
const GenericCards = ({
    backgroundColor,
    buttons,
    cards,
    ctaCssClass,
    ctaLabel,
    ctaLink,
    richText,
    title,
    wrapperClass
}) => {
    return (
        <section className={`${wrapperClass ? wrapperClass : ' col-padding'} bg-surface-panel-${backgroundColor} pb-8 md:pb-16 pt-24 rounded-lg flex-grow`}>
            <h2 className='type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                {title}
            </h2>

            {richText && (
                <div
                    className='rich-text type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'
                    dangerouslySetInnerHTML={{ __html: richText }} />
            )}

            <div className='mt-24 md:mt-40 sm:grid-cols-4 gap-8 md:gap-16 grid'>
                {cards.map((partner) => {
                    return (
                        <div
                            className='bg-surface-raised p-16 rounded-lg grid grid-y-16 grid-rows-subgrid'
                            key={partner.id}
                            style={{ gridRow: 'span 2'}}>
                            <p className='type-style-sans-h3-med'>
                                {partner.title}
                            </p>

                            {partner.text && (
                                <p className='type-style-sans-body'>
                                    {partner.text}
                                </p>
                            )}
                        </div>
                    );
                })}
            </div>

            {buttons?.length > 0 && (
                <div className='mt-24 sm:mt-40 flex flex-wrap gap-x-8'>
                    {buttons.map((button, idx) => {
                        return (
                            <Button
                                as='a'
                                className={`${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                href={formatLinkBlockToUrl(button.ctaLink)}
                                key={button.id}>
                                {button.ctaLabel}
                            </Button>
                        );
                    })}
                </div>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default GenericCards;
